export const embedCodeWidth = "480";

export const embedCodeHeight = "480";
